var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAverage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8195 33.4684C26.1087 33.4684 33.639 25.9763 33.639 16.7342C33.639 7.49216 26.1087 0 16.8195 0C7.53035 0 0 7.49216 0 16.7342C0 25.9763 7.53035 33.4684 16.8195 33.4684Z",
    fill: "#FCC419"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.97216 15.0923C11.0608 15.0923 11.9434 14.1754 11.9434 13.0444C11.9434 11.9133 11.0608 10.9964 9.97216 10.9964C8.88351 10.9964 8.00098 11.9133 8.00098 13.0444C8.00098 14.1754 8.88351 15.0923 9.97216 15.0923Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5503 15.0486C24.6389 15.0486 25.5215 14.1316 25.5215 13.0006C25.5215 11.8695 24.6389 10.9526 23.5503 10.9526C22.4616 10.9526 21.5791 11.8695 21.5791 13.0006C21.5791 14.1316 22.4616 15.0486 23.5503 15.0486Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0828 23.649H12.5562C12.1585 23.649 11.8359 23.3281 11.8359 22.9323C11.8359 22.5366 12.1585 22.2157 12.5562 22.2157H21.0828C21.4806 22.2157 21.8031 22.5366 21.8031 22.9323C21.8031 23.3281 21.4806 23.649 21.0828 23.649Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAverage);
export default __webpack_public_path__ + "static/media/average.9a86b797dc7fc8c4c542280cf7bbb9f8.svg";
export { ForwardRef as ReactComponent };